import { useEffect, useState } from "react";
import { Sparkle, ArrowClockwise } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AiSummary() {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [model, setModel] = useState("");
  useEffect(() => { api.get("/settings/ai").then((r) => setModel(r.data.provider)).catch(() => setModel("gpt")); }, []);

  const run = async () => {
    setBusy(true);
    setErr("");
    setText("");
    try {
      const res = await fetch(`${API}/ai/summary?model=${model}`, { credentials: "include" });
      if (!res.ok) throw new Error("İstek başarısız");
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
          const line = p.replace(/^data: /, "").trim();
          if (!line || line === "[DONE]") continue;
          const payload = JSON.parse(line);
          if (payload.error) setErr(payload.error);
          else setText((s) => s + payload.text);
        }
      }
    } catch {
      setErr("Özet oluşturulamadı. Lütfen tekrar deneyin.");
    }
    setBusy(false);
  };

  return (
    <div className="panel p-6" data-testid="ai-summary-panel">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="flex items-center gap-2 font-display text-lg font-bold"><Sparkle size={18} weight="fill" className="text-teal-700" /> Akıllı Özet</h3>
          <p className="text-[11px] text-muted-foreground">Güncel cari, tahsilat ve stok verilerinizden yönetici özeti ve öneriler üretir.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <div className="flex border border-border text-xs" data-testid="ai-model-toggle">
            {[["gpt", "ChatGPT"], ["gemini", "Gemini"], ["claude", "Claude"]].map(([k, l]) => (
              <button key={k} type="button" disabled={busy} onClick={() => setModel(k)} data-testid={`ai-model-${k}`}
                className={`px-3 py-2 transition-colors ${model === k ? "bg-zinc-900 text-white" : "hover:bg-muted"}`}>{l}</button>
            ))}
          </div>
          <Button onClick={run} disabled={busy} className="rounded-[4px] bg-teal-700 hover:bg-teal-800" data-testid="ai-summary-button">
            {text ? <ArrowClockwise /> : <Sparkle />} {busy ? "Yazılıyor…" : text ? "Yeniden Oluştur" : "Özet Oluştur"}
          </Button>
        </div>
      </div>
      {err && <div className="border border-red-300 bg-red-50 p-3 text-sm text-red-700" data-testid="ai-summary-error">{err}</div>}
      {(text || busy) && (
        <div className="whitespace-pre-wrap border border-border bg-muted/30 p-4 text-sm leading-6" data-testid="ai-summary-text">
          {text}{busy && <span className="ml-0.5 inline-block h-4 w-2 animate-pulse bg-teal-700 align-middle" />}
        </div>
      )}
    </div>
  );
}
